import { createApp } from "vue";

import "~/api/clientConfig";
import { router } from "~/router";
import App from "~/App.vue";

const el = document.getElementById("app");

if (el) {
  createApp(App).use(router).mount(el);
}
